import React, { Component } from "react";
import "./ExperienceCard.css";

import {ThemeProps} from "../../components/styles/themeprops";
import { useTranslation } from "react-i18next";

type State = {
}
type Project = {name: string,desc:string,stack:string}
type Exp = {
  title: string,
  company: string,
  company_url: string,
  logo_path:string,
  duration: string,
  location: string,
  color: string,
  projects: Project[],
}
type Props = {
  experience:Exp,
  theme: ThemeProps,
}
export default function ExperienceCard({ experience,theme }: Props) {
		const { t, i18n } = useTranslation();
    return (
      <div
        className="experience-card"
        style={{ border: `1px solid ${experience.color}` }}
      >
        <div className="experience-card-logo-div">
          <img
            className="experience-card-logo"
            src={require(`../../assests/images/${experience["logo_path"]}`)}
            alt=""
          />
        </div>
        <div className="experience-card-body-div">
          <div className="experience-card-header-div">
            <div className="experience-card-heading-left">
              <h3
                className="experience-card-title"
                style={{ color: theme.text }}
              >
                {experience["title"]}
              </h3>
              <p
                className="experience-card-company"
                style={{ color: theme.text }}
              >
                <a
                  href={experience["company_url"]}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: theme.text }}
                >
                  {experience["company"]}
                </a>
              </p>
            </div>
            <div className="experience-card-heading-right">
              <p
                className="experience-card-duration"
                style={{ color: theme.text }}
              >
                {experience["duration"]}
              </p>
              <p
                className="experience-card-location"
                style={{ color: theme.text }}
              >
                {experience["location"]}
              </p>
            </div>
          </div>
          <p className="experience-card-description" style={{ color: theme.text }} >
            <ol className="projectlist">
	            {experience.projects.map((project) => {
	            return (
              	<li title={project.name} key={project.name} className="experience-card-project">
              		<div><b>{project.name}</b></div>
              		<div>{project.desc}</div>
              		<div className="experience-card-project-stack"><b>Technology Stack:</b>{project.stack}</div>
              	</li>
	            );
	          	})}
          	</ol>
          
          </p>
        </div>
      </div>
    );
}
